import { Link } from "react-router-dom";
import { Bot, ExternalLink } from "lucide-react";
import { useAccess } from "@/lib/access";
import { openOwner } from "@/components/shell/OwnerPin";
import { PMAccountCard } from "@/components/bot/PMAccountCard";
import { LiveTradingCard } from "@/components/bot/LiveTradingCard";
import { PicksRealCard } from "@/components/bots/PicksRealCard";
import { CoinbaseCard } from "@/components/bots/CoinbaseCard";

const TrenchCard = () => (
  <section className="glass p-5" data-testid="trench-card">
    <h2 className="font-head font-semibold flex items-center gap-2">trench.io</h2>
    <p className="text-xs text-slate-400 mt-1">trench.io has no public API for balances or trading. It runs on a self-custodial wallet, and every trade is an on-chain ticket. So no app can safely connect to it or trade it for you. Keep using it directly. Remember the "1000x payout multiplier" is a high-risk payout model, not normal leverage.</p>
    <a href="https://trench.io/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-xs text-[var(--cyan)] mt-2" data-testid="trench-link">Open trench.io <ExternalLink className="w-3 h-3" /></a>
  </section>
);

export default function Bots() {
  const access = useAccess();
  if (!access.owner) return (
    <div className="glass p-6 space-y-3 max-w-lg" data-testid="bots-locked">
      <h1 className="font-head font-bold text-2xl flex items-center gap-2"><Bot className="w-6 h-6 text-[var(--cyan)]" />Trading bots</h1>
      <p className="text-sm text-slate-400">Only the app owner can connect accounts and run bots. Everyone else can follow the paper practice bot on the <Link to="/predict" className="text-[var(--cyan)]">Predict</Link> page.</p>
      <button onClick={openOwner} className="btn-primary !bg-[var(--gold)]" data-testid="bots-unlock-btn">Enter owner PIN</button>
    </div>
  );
  return (
    <div className="space-y-5" data-testid="bots-page">
      <div className="flex flex-wrap items-center justify-between gap-3"><div className="text-[11px] font-bold uppercase tracking-[.18em] text-[var(--gold)]">Owner console</div>
        <button onClick={access.logout} className="text-xs text-slate-500 hover:text-slate-300 underline" data-testid="owner-logout-btn">Lock console</button></div>
      <div><h1 className="font-head font-extrabold text-4xl">Bots & accounts</h1>
        <p className="text-sm text-slate-400 mt-1">Every bot starts on paper. Flip a switch to real money when you like its paper results. Bets are sized from your balance (default 33%: $10 → $3, $15 → $5). Nothing is guaranteed. Bots can lose money.</p></div>
      <h2 className="font-head font-semibold text-lg">Accounts</h2>
      <div className="grid lg:grid-cols-2 gap-4"><PMAccountCard tick={0} /><TrenchCard /></div>
      <h2 className="font-head font-semibold text-lg pt-2">Bots</h2>
      <LiveTradingCard />
      <PicksRealCard />
      <CoinbaseCard />
    </div>
  );
}
